import { Button, Text } from '#atoms';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import styled from 'styled-components';

import CertificationMark from '#assets/svg/CertificationMark.svg';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { DragHandle } from '#assets/svg';
import {
  ButtonBox,
  CertificationTag,
  Container,
  HandleBox,
  ImgBox,
  PointText,
  PortfolioCard,
  PortfolioInfo,
  PostingBox
} from './styles';
import { dummyDataType } from '#pages/PortfolioList';
interface UpdateListprops {
  postData: dummyDataType[];
  hideData: dummyDataType[];
  onClickUpdateList: (
    postList: dummyDataType[],
    hideList: dummyDataType[]
  ) => void;
  onClose: () => void;
}

export const PortfolioListUpdate = ({
  postData,
  hideData,
  onClickUpdateList,
  onClose
}: UpdateListprops) => {
  const hideMemberName = (name: string) => {
    const hideName = name[0] + '*'.repeat(name.length - 1);
    return hideName;
  };
  const [pData, setPostData] = useState(postData);
  const [hData, setHideData] = useState(hideData);

  const onDragEnd = (
    result: any,
    data: dummyDataType[],
    setData: Dispatch<SetStateAction<dummyDataType[]>>
  ) => {
    const { source, destination } = result;

    // 드래그가 유효하지 않다면 리턴
    if (!destination) return;

    // 리스트 내에서 아이템을 재정렬
    const reorderedData = Array.from(data);
    const [removed] = reorderedData.splice(source.index, 1);
    reorderedData.splice(destination.index, 0, removed);

    setData(reorderedData); // 업데이트된 리스트 반영
  };
  const arraysAreEqual = (arr1: dummyDataType[], arr2: dummyDataType[]) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item.title === arr2[index].title);
  };
  const moveData = (type: number, idx: number) => {
    if (type === 0) {
      // 0 은 숨김 처리
      const delData = pData.filter((data, index) => {
        if (idx !== index) return data;
        else setHideData([...hData, data]);
      });
      setPostData(delData);
    } else if (type === 1) {
      // 은 게시 처리
      const delData = hData.filter((data, index) => {
        if (idx !== index) return data;
        else setPostData([...pData, data]);
      });
      setHideData(delData);
    }
  };
  return (
    <>
      <PrevHeaderBarWithTitleTemplate
        title=""
        onPrev={onClose}
        defaultBackground
      >
        <Container>
          <Text
            style={{ fontSize: '2.4rem', fontWeight: 700, lineHeight: '3rem' }}
          >
            순서를 바꾸거나 <br /> 목록에서 숨길 수 있어요
          </Text>
          <div>
            <Text style={{ color: '#8e899f' }}>
              게시중 <PointText>{pData.length}</PointText>
            </Text>
            <PostingBox>
              <DragDropContext
                onDragEnd={result => onDragEnd(result, pData, setPostData)}
              >
                <Droppable droppableId="droppable">
                  {provided => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {pData.map((post, index) => (
                        <Draggable
                          key={post.title}
                          draggableId={post.title}
                          index={index}
                        >
                          {provided => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                marginBottom: '10px' // 드래그 아이템 간 간격 추가
                              }}
                            >
                              <PortfolioCard>
                                <ImgBox>
                                  <img src={post.img.resizedLink} />
                                </ImgBox>
                                <PortfolioInfo>
                                  {post.isCertification && (
                                    <CertificationTag>
                                      <img
                                        src={CertificationMark}
                                        alt="Certification Mark"
                                      />
                                      운동차트 인증
                                    </CertificationTag>
                                  )}
                                  <Text style={{ fontSize: '1.6rem' }}>
                                    {post.title}
                                  </Text>
                                  <Text
                                    textStyle="c2"
                                    style={{ color: '#8e899f' }}
                                  >
                                    {hideMemberName(post.memberName)} 회원님
                                  </Text>
                                </PortfolioInfo>
                                <HandleBox>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M20 9H4V11H20V9ZM4 15H20V13H4V15Z"
                                      fill="#5C576B"
                                    />
                                  </svg>
                                  <Text onClick={() => moveData(0, index)}>
                                    숨김
                                  </Text>
                                </HandleBox>
                              </PortfolioCard>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </PostingBox>
          </div>
          <div style={{ paddingBottom: '6rem' }}>
            <Text style={{ color: '#8e899f' }}>
              숨긴 트레이닝 성과 <PointText>{hData.length}</PointText>
            </Text>
            <PostingBox>
              <DragDropContext
                onDragEnd={result => onDragEnd(result, hData, setHideData)}
              >
                <Droppable droppableId="droppable">
                  {provided => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {hData.map((post, index) => (
                        <Draggable
                          key={post.title}
                          draggableId={post.title}
                          index={index}
                        >
                          {provided => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                marginBottom: '10px' // 드래그 아이템 간 간격 추가
                              }}
                            >
                              <PortfolioCard>
                                <ImgBox>
                                  <img src={post.img.resizedLink} />
                                </ImgBox>
                                <PortfolioInfo>
                                  {post.isCertification && (
                                    <CertificationTag>
                                      <img
                                        src={CertificationMark}
                                        alt="Certification Mark"
                                      />
                                      운동차트 인증
                                    </CertificationTag>
                                  )}
                                  <Text style={{ fontSize: '1.6rem' }}>
                                    {post.title}
                                  </Text>
                                  <Text
                                    textStyle="c2"
                                    style={{ color: '#8e899f' }}
                                  >
                                    {hideMemberName(post.memberName)} 회원님
                                  </Text>
                                </PortfolioInfo>
                                <HandleBox>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M20 9H4V11H20V9ZM4 15H20V13H4V15Z"
                                      fill="#5C576B"
                                    />
                                  </svg>
                                  <Text onClick={() => moveData(1, index)}>
                                    게시
                                  </Text>
                                </HandleBox>
                              </PortfolioCard>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </PostingBox>
          </div>
        </Container>
        <ButtonBox>
          <Button
            disabled={
              arraysAreEqual(postData, pData) && arraysAreEqual(hideData, hData)
            }
            onClick={() => onClickUpdateList(pData, hData)}
          >
            확인
          </Button>
        </ButtonBox>
      </PrevHeaderBarWithTitleTemplate>
    </>
  );
};
